<template>
    <QrHeader :text="trans('header.create-qr-code')" trans="header.create-qr-code"/>

    <div class="gap-4 mt-4">
        <QrForm @submit.prevent="next" class="space-y-4">
            <div class="flex space-x-4">
                <button
                    v-for="product in mainProducts"
                    @click="newQrCode.product_id = product.id"
                    type="button"
                    class="flex flex-col border-2 py-2 px-3 rounded-xl w-full min-h-24"
                    :class="newQrCode.product_id === product.id && 'border-green-500'"
                >
                    <span class="my-auto">
                        <QrParagraph :text="product.name" class="text-md font-medium"/>
                        <QrParagraph :text="product.price_readable" class="text-sm"/>
                    </span>
                </button>
            </div>

            <QrInput v-model="newQrCode.name" :label="trans('qrcode.name-your-qr-code')" trans="qrcode.name-your-qr-code"/>
        </QrForm>

        <div class="flex justify-between mt-4">
            <QrButton
                to="/dashboard"
                :text="trans('button.cancel')"
                @click="qrCodeStore.resetNewQrCode"
                trans="button.cancel"
                secondary
                icon-right="times"
            />

            <QrButton
                :text="trans('button.continue')"
                trans="button.continue"
                icon-right="arrow-right"
                :disabled="!newQrCode.name"
                :loading="loading"
                @click="next"
            />
        </div>
    </div>
</template>

<script setup>
import { trans } from "@/libs/helper.js";
import QrInput from "@/components/application-ui/form/QrInput.vue";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import { useQrCodesStore} from "@/store/qrCodes.js";
import { storeToRefs } from "pinia";
import { computed, onMounted } from "vue";
import { useProductsStore } from "@/store/products.js";
import QrParagraph from "@/components/application-ui/content/QrParagraph.vue";
import { useRouter } from "vue-router";

const router = useRouter();

const qrCodeStore = useQrCodesStore();
const { newQrCode, qrCode, loading } = storeToRefs(qrCodeStore);

const productsStore = useProductsStore();

const mainProducts = computed(() => productsStore.products.filter(product => !product.is_additional))

const next = () => {
    if (! newQrCode.value.name || ! newQrCode.value.product_id) {
        return
    }

    if (qrCode.value) {
        router.push(`/create/type/${qrCode.value.id}`)
    } else {
        router.push('/create/type')
    }
};

onMounted(() => {
    newQrCode.value.step = 1
});
</script>
